<app-loading></app-loading>
<div class="narbar">
    <app-navbar [menuStatus]="side" (updateMenu)="side = $event"></app-navbar>
</div>
<div class="box-content" *ngIf="tn.viewPage">
    <!-- <div class="view-menu" [ngClass]="{'d-none':side || !app.viewPage}">
        <span class="material-symbols-outlined" (click)="side = true">
            menu
        </span>
    </div> -->
    <div class="sidebar" [ngClass]="{'on':side, 'd-none':!app.viewPage,'mini':!side}">
        <app-sidebar2 [menuStatus]="side" (updateSide)="side = false"></app-sidebar2>

    </div>
    <div class="content scrollbar">
        <br>
        <router-outlet></router-outlet>
        <br><br><br>
    </div>
</div>


<div class="box-license" *ngIf="!app.License">
    <div class="d-flex w-100 h-100 align-items-center">
        <div class="card w-100 p-3 m-auto">
            <br>
            <div class="row g-3">
                <div class="col-12">
                    <div class="logo">
                        <img width="137px" src="assets/logo/logo-kraken.svg" alt="">
                    </div>
                </div>
                <div class="col-12">
                    <h5><b>ไม่มีใบอนุญาต</b></h5>
                </div>
                <div class="col-12">
                    <button class="btn btn-primary w-100" (click)="UseLicense()">ใส่ ใบอนุญาต</button>
                </div>
                <div class="col-12">
                    <button class="btn btn-cancel w-100" (click)="buyPackage()">ซื้อ ใบอนุญาต</button>
                </div>
                <div class="col-12">
                    <span class="fs-14 text-decoration-underline pointer" (click)="toBack()">ย้อนกลับ</span>
                </div>
            </div>
            <br>
        </div>
    </div>
    <!-- <h1>ไม่มี License</h1>
    <button class="btn btn-primary" (click)="UseLicense()">ใส่ License</button>
    <br>
    <br>
    <button class="btn btn-primary" (click)="buyPackage()">ซื้อ License</button>
    <br>
    <br>
    <button class="btn btn-primary" (click)="toBack()">ย้อนกลับ</button> -->
</div>